'use client'

import * as React from 'react'
import { Editor } from '@tiptap/react'
import { LinkHoverCard } from '@/tiptap/tiptap-ui/link-hover-card/link-hover-card'
import { LinkFloatingEditor } from '@/tiptap/tiptap-ui/link-popover/link-floating-editor'

interface LinkManagerProps {
  editor: Editor
}

export function LinkManager({ editor }: LinkManagerProps) {
  const [isEditing, setIsEditing] = React.useState(false)
  const [initialMode, setInitialMode] = React.useState<'edit' | 'view' | 'search'>('view')
  const [cursorPosition, setCursorPosition] = React.useState<{ from: number; to: number } | null>(null)
  const [slashCommandRange, setSlashCommandRange] = React.useState<{ from: number; to: number } | null>(null)
  
  const handleEdit = React.useCallback(() => {
    setInitialMode('view')
    setCursorPosition(null) // Use current selection for hover edit
    setSlashCommandRange(null)
    setIsEditing(true)
  }, [])
  
  const handleClose = React.useCallback(() => {
    setIsEditing(false)
    setCursorPosition(null)
    setSlashCommandRange(null)
  }, [])
  
  // Listen for openLinkDialog event from slash command
  React.useEffect(() => {
    const handleOpenDialog = (props?: { range?: { from: number; to: number } }) => {
      // Store the slash command range to delete it later
      if (props?.range) {
        setSlashCommandRange(props.range)
        // Don't set cursor position - use current selection for slash commands
        setCursorPosition(null)
      } else {
        setCursorPosition(null)
        setSlashCommandRange(null)
      }
      setInitialMode('search')
      setIsEditing(true)
    }
    
    editor.on('openLinkDialog', handleOpenDialog)
    
    return () => {
      editor.off('openLinkDialog', handleOpenDialog)
    }
  }, [editor])
  
  return (
    <>
      <LinkHoverCard editor={editor} onEdit={handleEdit} />
      <LinkFloatingEditor
        editor={editor}
        isOpen={isEditing}
        onClose={handleClose}
        initialMode={initialMode}
        cursorPosition={cursorPosition}
        slashCommandRange={slashCommandRange}
      />
    </>
  )
}